"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoController = void 0;

var PIXI = _interopRequireWildcard(require("pixi.js-legacy"));

var _ = require("../../../");

var _helpers = require("../../../util/helpers");

var _Queue = require("./Queue");

var _SpeedTestJob = require("./jobs/SpeedTestJob");

var _PlayJob = require("./jobs/PlayJob");

var _PauseJob = require("./jobs/PauseJob");

var _VideoInfoUpdateJob = require("./jobs/VideoInfoUpdateJob");

var _SeekJob = require("./jobs/SeekJob");

var _UnloadStreamJob = require("./jobs/UnloadStreamJob");

var _LoadMainStreamJob = require("./jobs/LoadMainStreamJob");

var _SwitchToMainStreamJob = require("./jobs/SwitchToMainStreamJob");

var _LoadingMode = require("./LoadingMode");

var _PositionVideosJob = require("./jobs/PositionVideosJob");

var _LoadCoachAudioJob = require("./jobs/LoadCoachAudioJob");

var _SyncSourcesJob = require("./jobs/SyncSourcesJob");

var _UpdateSubSourcesJob = require("./jobs/UpdateSubSourcesJob");

var _Tracker = require("../../../util/Tracker");

var _isiOS = require("../../../util/isiOS");

var _VideoSettings = require("./VideoSettings");

var _exitFullScreen = require("../exitFullScreen");

var _TimeRange = require("../../../util/TimeRange");

var _Time = require("../../../util/Time");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VideoControllerId = 1; /// multicam=stacked

/**
 * VideoController controls video playback.
 *
 * @property {number} id - The id of the video controller.
 * @property {string} videoId - The id of the video.
 * @property {boolean} needsLoad - Whether or not the video needs to be loaded.
 * @property {boolean} needsSetup - Whether or not the video needs to be setup.
 * @property {Moment} moment - The current moment.
 * @property {number} loopCount - The number of times the video has looped.
 * @property {Array<Plugin>} plugins - The plugins to apply to the video.
 * @property {VideoTracker} tracker - The video analytics tracker.
 * @property {boolean} active - Whether or not the video is active.
 * @property {boolean} paused - Whether or not the video is paused.
 * @property {boolean} loop - Whether or not the video should loop.
 * @property {boolean} muted - Whether or not the video is muted.
 * @property {boolean} zoom - Whether or not the video is zoomed.
 * @property {number} startAt - The video time the video should start at
 * @property {number} stopAt - The video time the video should stop at
 * @property {boolean} freeze - Whether the video should freeze at the startAt time.
 * @property {boolean} isResizing - Whether the video is resizing.
 * @property {boolean} sourceChooserOpen - Whether the source chooser is open.
 * @property {Array<Object>} mainSources - The main moment and video element pairs.
 * @property {Array<Object>} subSources - The sub moment and video element pairs.
 * @property {Object} controllingSource - The controlling video element, moment and hls.
 * @property {Array<Object>} cameras - array of camera objects.
 * @property (LoadingMode) loadingMode - The loading mode.
 * @export
 * @class VideoController
 */

var VideoController = /*#__PURE__*/function () {
  //! Constructor
  function VideoController(id) {
    _classCallCheck(this, VideoController);

    VideoControllerId++;
    var controllerId = id ? id : VideoControllerId; // private properties

    this._lastVideoInfoUpdate = "";
    this._playlistController = null; // setup properties

    this.id = controllerId;
    this.needsLoad = false;
    this.needsSetup = false;
    this._moment = null;
    this._displayMoment = null;
    this._nextMoment = null;
    this.pendingPause = false;
    this.loopCount = 0;
    this.plugins = [];
    this.track = null;
    this.displayMomentTrack = null;
    this.playlistId = null;
    this.userId = null;
    this.playlistType = null;
    this.category = null;
    this.action = null;
    this.label = null;
    this.playerType = null;
    this.videoId = "";
    this.active = false;
    this.loop = false;
    this.fluid = true;
    this.startAt = 0;
    this.startAtOnce = 0;
    this.fluidStart = 0;
    this.stopAt = null;
    this.freeze = null;
    this.isResizing = false;
    this.mainSources = [];
    this.subSources = [];
    this.sourceChooserOpen = false;
    this.loadingMode = (0, _helpers.isMobile)() ? _LoadingMode.LoadingMode.MED : _LoadingMode.LoadingMode.HIGH;
    this.isFullscreen = false;
    this.cameras = [];
    this.camerasWithId = [];
    this.defaultCamera = "tracecam";
    this.resumeAt = null;
    this._networkSpeed = null;
    this._prevReadyState = 0;
    this._bufferingCount = 0;
    this._firstLoadComplete = false;
    this.doVideoInfoUpdateLocked = false;
    this.settings = _VideoSettings.VideoSettings.getInstance(this.id);
    this.lastMouseLocation = {
      x: 0,
      y: 0
    };
    this.initialLoading = true;
    this.lastSync = 0;
    this.insideMoment = false; // settings

    this._muted = true;
    this.zoom = false;
    this.locked = false; // video controls

    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.jump = this.jump.bind(this);
    this.jumpForward = this.jumpForward.bind(this);
    this.jumpBackward = this.jumpBackward.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onJump = this.onJump.bind(this);
    this.onJumpForward = this.onJumpForward.bind(this);
    this.onJumpBackward = this.onJumpBackward.bind(this);
    this.activityDetected = this.activityDetected.bind(this);
    this.onInteraction = this.onInteraction.bind(this); // event handlers

    this.doVideoInfoUpdate = this.doVideoInfoUpdate.bind(this);
    this.drawUpdate = this.drawUpdate.bind(this);
    this.onVideoEnded = this.onVideoEnded.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.onSomeVideoEnded = this.onSomeVideoEnded.bind(this);
    this.onFullscreenEnter = this.onFullscreenEnter.bind(this);
    this.onFullscreenExit = this.onFullscreenExit.bind(this); // prop like event handlers

    this.onVideoClick = null; // queues

    this.mainQueue = new _Queue.Queue();
    this.mainQueue.maxConcurrent = 1;
    this.videoControlsQueue = new _Queue.Queue();
    this.videoControlsQueue.maxConcurrent = 1;
  } //! Getter and Setter Methods


  _createClass(VideoController, [{
    key: "sleep",
    value: function sleep(time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          resolve(true);
        }, 200);
      });
    }
  }, {
    key: "moment",
    get: function get() {
      return this._moment;
    },
    set: function set(val) {
      var current = JSON.stringify(this._moment, null, 2);
      var next = JSON.stringify(val, null, 2);

      if (current !== next) {
        //set initialloading to true here
        this.initialLoading = true;
        this._moment = val;
        this.cleanup(true);
        this.needsLoad = true;
        this.needsSetup = true;
        this.generateSources(val);
      }
    }
  }, {
    key: "displayMoment",
    get: function get() {
      return this._displayMoment;
    },
    set: function set(val) {
      if (this._displayMoment !== val) {
        this._displayMoment = val;
        this.displayMomentTrack = null; //display moment has changed to another one, let's create new tracker for it

        this.createDisplayMomentTracker();
      }
    }
  }, {
    key: "controllingSource",
    get: function get() {
      var src = null;

      var _iterator = _createForOfIteratorHelper(this.mainSources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var source = _step.value;

          if (source.active) {
            src = source;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return src;
    }
  }, {
    key: "audioElements",
    get: function get() {
      var container = this.containerElement;
      var elements = [];

      if (container) {
        var els = container.querySelectorAll("audio");

        var _iterator2 = _createForOfIteratorHelper(els),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var el = _step2.value;
            elements.push(el);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return elements;
    }
  }, {
    key: "videoElements",
    get: function get() {
      var container = this.containerElement;
      var elements = [];

      if (container) {
        var els = container.querySelectorAll("video");

        var _iterator3 = _createForOfIteratorHelper(els),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var el = _step3.value;
            elements.push(el);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return elements;
    }
  }, {
    key: "subVideoSourceContainers",
    get: function get() {
      var container = this.subVideoContainerElement;
      var elements = [];

      if (container) {
        var els = container.querySelectorAll(".sub-video-container");

        var _iterator4 = _createForOfIteratorHelper(els),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var el = _step4.value;
            elements.push(el);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      return elements;
    }
  }, {
    key: "canvasContainerElement",
    get: function get() {
      var container = this.containerElement;
      var canvasContainer = null;

      if (container) {
        canvasContainer = container.querySelector(".canvas-container");
      }

      return canvasContainer;
    }
  }, {
    key: "canvasElements",
    get: function get() {
      var elements = [];

      if (this.containerElement) {
        elements = this.containerElement.querySelectorAll(".canvas-container canvas");
      }

      return elements;
    }
  }, {
    key: "subVideoContainerElement",
    get: function get() {
      var el = null;

      if (this.containerElement) {
        el = this.containerElement.querySelector(".sub-videos");
      }

      return el;
    }
  }, {
    key: "containerElement",
    get: function get() {
      if (!this._containerElement || this._containerElement.id !== this.videoId) {
        this._containerElement = document.getElementById(this.videoId);
      }

      return this._containerElement;
    }
  }, {
    key: "loadingElement",
    get: function get() {
      var el = null;

      if (this.containerElement) {
        el = this.containerElement.querySelector(".large-loading");
      }

      return el;
    }
  }, {
    key: "loadingOverlayElement",
    get: function get() {
      var el = null;

      if (this.containerElement) {
        el = this.containerElement.querySelector(".loading-screen");
      }

      return el;
    }
  }, {
    key: "eventsPanelElement",
    get: function get() {
      if (!this._eventsPanelElement) {
        this._eventsPanelElement = document.querySelector(".EventsPanel #video-size");
      }

      return this._eventsPanelElement;
    }
  }, {
    key: "paused",
    get: function get() {
      var _this$controllingSour;

      if ((_this$controllingSour = this.controllingSource) !== null && _this$controllingSour !== void 0 && _this$controllingSour.video) {
        return this.controllingSource.video.paused;
      }

      return false;
    }
  }, {
    key: "muted",
    get: function get() {
      return this._muted;
    },
    set: function set(val) {
      if (this._muted !== val) {
        this._muted = val;

        if (this.controllingSource && this.controllingSource.video) {
          this.controllingSource.video.muted = val;
        }
      }
    }
  }, {
    key: "cameraForMoment",
    value: function cameraForMoment(moment) {
      var camera = null;

      if (moment && moment.camera) {
        camera = moment.camera;
      } else if (moment && moment.meta) {
        camera = moment.meta.camera;
      }

      return camera;
    }
    /**
     * updates video controller with info about the video player
     *
     * @param {Moment} moment
     * @param {string} videoId - id of the video player component
     * @memberof VideoController
     */

  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(moment, videoId, cameras, defaultCamera) {
        var a, b;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                a = (0, _.getProperty)("game_clip_id", moment, "a");
                b = (0, _.getProperty)("game_clip_id", this.moment, "a");
                this.mainQueue.clear();
                this.videoControlsQueue.clear();

                if (a !== b) {
                  this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(this.controllingSource));
                  this.unloadVideoForMultiCam();
                } // default camera from url, removing this would stay on the currently
                // selected camera


                this.videoId = videoId;
                this.cameras = cameras;
                this.defaultCamera = defaultCamera;
                this.moment = moment;

                if (this.videoElements.length === 0) {
                  console.warn("VideoController.update no video elements aboring update");
                }

                this.mainQueue.clear();
                this.videoControlsQueue.clear();
                this.loadVideo(true);
                this.setupEventHandlers();

                if (this.sourceChooserOpen) {
                  this.loadVideoForMultiCam(-1, false, false);
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update(_x, _x2, _x3, _x4) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "generateSources",
    value: function generateSources() {
      var _this$controllingSour2,
          _this = this;

      var videoElements = this.videoElements;
      var subContainers = this.subVideoSourceContainers;
      var moments = [];
      var subSources = [];
      var mainSources = []; // build moments array

      if (this.moment) {
        moments.push(this.moment);

        if (Array.isArray(this.moment.sources)) {
          moments = moments.concat(this.moment.sources);
        }
      } // console.log("VideoController.generateSources moments array", moments)
      // build sources


      var _iterator5 = _createForOfIteratorHelper(this.cameras),
          _step5;

      try {
        var _loop = function _loop() {
          var cam = _step5.value;
          var moment = void 0;

          if (cam.name === "singlecam") {
            moment = _this.moment;
          } else {
            moment = moments.find(function (m) {
              return cam.game_clip_id === m.game_clip_id;
            });
          }

          var mainVideoElement = cam.name === "singlecam" ? videoElements[0] : videoElements.find(function (el) {
            return el.id.includes("".concat(_this.videoId, "-main-").concat(cam.name, "-").concat(cam.game_clip_id));
          });
          var main = {
            camera: cam.name,
            video: mainVideoElement,
            container: null,
            moment: moment,
            hls: null,
            active: false,
            enabled: true
          };
          mainSources.push(main);
          var subMoment = moments.find(function (m) {
            return cam.game_clip_id === m.game_clip_id;
          });

          if (cam.name !== "singlecam") {
            var subVideoElement = cam.name === "singlecam" ? videoElements[0] : videoElements.find(function (el) {
              return el.id.includes("".concat(_this.videoId, "-sub-").concat(cam.name, "-").concat(cam.game_clip_id));
            });
            var subVideoContainer = cam.name === "singlecam" ? subContainers[0] : subContainers.find(function (el) {
              return el.id.includes("".concat(_this.videoId, "-sub-container-").concat(cam.name, "-").concat(cam.game_clip_id));
            });
            var sub = {
              camera: cam.name,
              video: subVideoElement,
              container: subVideoContainer,
              moment: subMoment,
              hls: null,
              active: false,
              enabled: ["singlecam", "tracecam"].includes(cam.name)
            };
            subSources.push(sub);
          }
        };

        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          _loop();
        } // find the active source

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var activeId = null;

      var fluidStartUTC = this._playlistController.fluidStartUTC();

      var startTime = _Time.Time.fromSeconds(fluidStartUTC, 0);

      if (this.defaultCamera) {
        var _iterator6 = _createForOfIteratorHelper(mainSources),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var source = _step6.value;

            var momentRange = _TimeRange.TimeRange.fromMoment(source.moment);

            momentRange.fuzz = 500;

            if (source.moment && source.camera === this.defaultCamera && momentRange.includes(startTime)) {
              source.active = true;
              activeId = source.moment.game_clip_id;
              break;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        var _iterator7 = _createForOfIteratorHelper(subSources),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _source = _step7.value;

            if (_source.moment && _source.camera === this.defaultCamera) {
              _source.active = true;
            } else {
              _source.enabled = false;
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }

      if (!activeId) {
        console.warn("VideoController.generateSources backupActive plan first available");

        var _iterator8 = _createForOfIteratorHelper(mainSources),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _source2 = _step8.value;

            if (_source2.moment && _source2.video) {
              _source2.active = true;
              activeId = _source2.moment.game_clip_id;
              break;
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        var _iterator9 = _createForOfIteratorHelper(subSources),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _source3 = _step9.value;

            if (_source3.moment && _source3.moment.game_clip_id === activeId) {
              _source3.active = true;
            } else {
              _source3.active = false;
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      } // clean up current sources


      var _iterator10 = _createForOfIteratorHelper(this.mainSources),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var src = _step10.value;

          if (src.hls) {
            this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(src));
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      var _iterator11 = _createForOfIteratorHelper(this.subSources),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _src = _step11.value;

          if (_src.hls) {
            this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(_src));
          }
        } // save the new sources

      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      this.subSources = subSources;
      this.mainSources = mainSources; // update pixi plugins to use new elements

      var video = (_this$controllingSour2 = this.controllingSource) === null || _this$controllingSour2 === void 0 ? void 0 : _this$controllingSour2.video;
      var div = this.containerElement;

      if (video && div) {
        var _iterator12 = _createForOfIteratorHelper(this.plugins),
            _step12;

        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var plugin = _step12.value;

            if (plugin.requiresCanvas() && plugin.pixi) {
              plugin.pixi.resizeTo = plugin.sizeToVideo() ? video : div;
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }
    } //! Plugins

  }, {
    key: "hasPlugin",
    value: function hasPlugin(name) {
      if (!name) {
        return false;
      }

      var found = false;

      var _iterator13 = _createForOfIteratorHelper(this.plugins),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var p = _step13.value;

          if (p._name === name) {
            found = true;
            break;
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      return found;
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      if (!plugin) {
        return;
      }

      if (!this.hasPlugin(plugin._name)) {
        this.plugins.push(plugin);
      }
    }
  }, {
    key: "removePlugin",
    value: function removePlugin(name) {
      if (!name) {
        return;
      }

      this.plugins = this.plugins.filter(function (plugin) {
        var matched = plugin._name !== name;

        if (!matched && plugin && plugin.scene) {
          plugin.reset();
        }

        return matched;
      });
    }
  }, {
    key: "createDisplayMomentTracker",
    value: function createDisplayMomentTracker() {
      if (this._displayMoment) {
        var _this$controllingSour3;

        var cam = this.cameraForMoment((_this$controllingSour3 = this.controllingSource) === null || _this$controllingSour3 === void 0 ? void 0 : _this$controllingSour3.moment);
        this.displayMomentTrack = new _.VideoTracker(this._displayMoment.game_clip_id, this.playlistId, this.userId, this.playlistType, this.category, this.action, (0, _.getProperty)("type", cam, "Trace"), this.playerType);
        this.displayMomentTrack.videoCount(this.displayMoment.game_clip_id);
        this.displayMomentTrack.videoStart();
      }
    }
  }, {
    key: "updateTrackingInfo",
    value: function updateTrackingInfo(vi) {
      //fluid mode and the current moment is in view -> update this moment tracking info
      if (this.fluid && this.insideMoment && this.displayMoment && this.displayMomentTrack) {
        var startAt = this._playlistController.fluidStart();

        var stopAt = this._playlistController.fluidStop();

        var updatedVi = Object.assign({}, vi, {
          currentTime: vi.currentTime - startAt,
          duration: stopAt - startAt
        });
        this.displayMomentTrack.update(updatedVi);
      } else {
        if (this.track) {
          this.track.update(vi);
        }
      }
    }
  }, {
    key: "doVideoInfoUpdate",
    value: function doVideoInfoUpdate() {
      var _this$controllingSour4;

      if (this.doVideoInfoUpdateLocked) {
        return;
      }

      var vi = this.buildVideoInfo();

      if (this._playlistController) {
        this._playlistController.onVideoTimeUpdate(vi.currentTime);
      }

      if (this.initialLoading) {
        (0, _.removeClassName)(this.loadingOverlayElement, "hide");
      } else {
        (0, _.addClassName)(this.loadingOverlayElement, "hide");
      }

      if (vi.readyState >= 3 && !this.initialLoading) {
        (0, _.addClassName)(this.loadingElement, "hide");
      } else {
        (0, _.removeClassName)(this.loadingElement, "hide");
      } // update full screen property
      // this.isFullscreen =
      //     !!document.webkitDisplayingFullscreen ||
      //     !!document.webkitCurrentFullScreenElement ||
      //     !!document.mozFullScreenElement ||
      //     !!document.msFullscreenElement ||
      //     !!document.fullscreenElement
      // track video play


      this.updateTrackingInfo(vi); // update plugins with video info

      var _iterator14 = _createForOfIteratorHelper(this.plugins),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var plugin = _step14.value;

          if (plugin.controlsVideo) {
            var pluginVideoInfo = plugin.videoInfo();
            vi = Object.assign({}, vi, pluginVideoInfo);
          }
        } // send video info update to any listeners

      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      var stime = Date.now();
      this.sendVideoInfoUpdate(vi);
      var dtime = Date.now() - stime;

      if (dtime > 300) {
        console.warn("doVideoInfoUpdate took ".concat(dtime, "ms"));
      } //this.syncVideos()
      // update video positions if needed


      if (this._lastVideoHeight !== ((_this$controllingSour4 = this.controllingSource) === null || _this$controllingSour4 === void 0 ? void 0 : _this$controllingSour4.video.videoHeight)) {
        var _this$controllingSour5;

        this._lastVideoHeight = (_this$controllingSour5 = this.controllingSource) === null || _this$controllingSour5 === void 0 ? void 0 : _this$controllingSour5.video.videoHeight;
        this.mainQueue.addItem(new _PositionVideosJob.PositionVideosJob(this.mainSources, this.subSources, this.containerElement, this.subVideoContainerElement, this.videoElements, this.sourceChooserOpen));
      }

      return vi;
    }
  }, {
    key: "drawSetup",
    value: function drawSetup(videoInfo) {
      var _this$controllingSour6;

      var video = (_this$controllingSour6 = this.controllingSource) === null || _this$controllingSour6 === void 0 ? void 0 : _this$controllingSour6.video;

      if (!video) {
        return;
      }

      var div = this.containerElement;

      if (!div) {
        return;
      }

      var canvasContainer = this.canvasContainerElement;

      if (!canvasContainer) {
        return;
      }

      var videoFrame = {
        x: 0,
        y: 0,
        w: Math.floor(video.offsetWidth),
        h: Math.floor(video.offsetHeight),
        s: 1
      };
      var containerFrame = {
        x: 0,
        y: 0,
        w: Math.floor(div.offsetWidth),
        h: Math.floor(div.offsetHeight),
        s: 1
      };

      var _iterator15 = _createForOfIteratorHelper(this.plugins),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var plugin = _step15.value;

          if (!plugin.canvas && plugin.requiresCanvas()) {
            var canvas = document.createElement("canvas");
            canvasContainer.appendChild(canvas);
            plugin.canvas = canvas;

            if (plugin.sizeToVideo()) {
              plugin.canvas.style.left = "".concat((div.offsetWidth - video.offsetWidth) / 2, "px");
              canvas.style.top = "".concat((div.offsetHeight - video.offsetHeight) / 2, "px");
            }

            plugin.pixi = new PIXI.Application({
              autostart: true,
              width: plugin.sizeToVideo() ? videoFrame.w : containerFrame.w,
              height: plugin.sizeToVideo() ? videoFrame.h : containerFrame.h,
              resizeTo: plugin.sizeToVideo() ? video : div,
              view: canvas,
              backgroundAlpha: 0,
              forceCanvas: true,
              antialias: true,
              autoDensity: true,
              resolution: window.devicePixelRatio ? window.devicePixelRatio : 1
            });
            plugin.pixi.renderer.plugins.interaction.autoPreventDefault = false;
            plugin.pixi.renderer.view.style.touchAction = "auto"; // plugin.pixi.renderer.on("resize", (width, height) => {
            //     console.log("VideoController: pixi resize", width, height)
            // })
          }

          plugin.videoId = this.videoId;

          if (plugin.requiresCanvas()) {
            plugin.scene = new PIXI.Container();
            plugin.pixi.stage.addChild(plugin.scene);
          }

          plugin.setup(plugin.sizeToVideo() ? _objectSpread({}, videoFrame) : _objectSpread({}, containerFrame), videoInfo, plugin.pixi);

          if (plugin.controlsVideo) {
            plugin.videoControls = {
              play: this.play,
              pause: this.pause
            };
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      this.startPixiTicker();
    }
  }, {
    key: "startPixiTicker",
    value: function startPixiTicker() {
      if (!this._startedTicker) {
        // console.log("VideoController.startPixiTicker")
        this._startedTicker = true;
        PIXI.Ticker.shared.add(this.doVideoInfoUpdate);
        PIXI.Ticker.shared.add(this.drawUpdate);
      }
    }
  }, {
    key: "stopPixiTicker",
    value: function stopPixiTicker() {
      PIXI.Ticker.shared.remove(this.doVideoInfoUpdate);
      PIXI.Ticker.shared.remove(this.drawUpdate);
    }
  }, {
    key: "timeWatchDogs",
    value: function timeWatchDogs(videoInfo) {
      var _this$controllingSour7;

      var startAt = videoInfo.fluid.startAt;
      var stopAt = videoInfo.fluid.stopAt;

      if (stopAt && (this.settings.loop || this.settings.locked || this.loop)) {
        var stopMin = stopAt - 0.1;
        var stopMax = stopAt + 0.1;

        if (stopMin <= videoInfo.currentTime && videoInfo.currentTime <= stopMax) {
          // console.log(
          //     "VideoController.timeWatchDogs: videoEnded",
          //     stopAt,
          //     startAt,
          //     videoInfo.currentTime
          // )
          this.onVideoEnded();
          return;
        }
      } // just in case ended events are not fired


      var video = (_this$controllingSour7 = this.controllingSource) === null || _this$controllingSour7 === void 0 ? void 0 : _this$controllingSour7.video;

      if (video) {
        if (video.currentTime >= video.duration - 0.25) {
          // console.log(
          //     "VideoController.timeWatchDogs: triggering videoEnded",
          //     video.currentTime,
          //     video.duration
          // )
          this.onVideoEnded();
          return;
        }
      }

      var syncDiff = Math.abs(videoInfo.currentTime - this.lastSync);

      if (syncDiff > 0.1 && !this.initialLoading && this.sourceChooserOpen) {
        this.lastSync = videoInfo.currentTime;
        this.mainQueue.addItem(new _UpdateSubSourcesJob.UpdateSubSourcesJob(this));
      }
    }
  }, {
    key: "drawUpdate",
    value: function drawUpdate() {
      var _this$controllingSour8;

      if (PIXI.Ticker.shared.elapsedMS > 300) {
        console.warn("VideoPlayer.drawUpdate took", PIXI.Ticker.shared.elapsedMS, "ms");
      }

      var stime = Date.now();
      var videoInfo = this.buildVideoInfo();
      this.timeWatchDogs(videoInfo); // try this out to speed uploading of ios

      if (this.initialLoading) {
        return;
      } // update plugins MUST RUN


      var video = (_this$controllingSour8 = this.controllingSource) === null || _this$controllingSour8 === void 0 ? void 0 : _this$controllingSour8.video;

      if (!video) {
        return;
      }

      var div = this.containerElement;

      if (!div) {
        return;
      }

      var containerFrame = {
        x: 0,
        y: 0,
        w: Math.floor(div.offsetWidth),
        h: Math.floor(div.offsetHeight),
        s: 1
      };
      var videoFrame = {
        x: 0,
        y: 0,
        w: Math.floor(video.offsetWidth),
        h: Math.floor(video.offsetHeight),
        s: 1
      }; // update all the plugin canvases

      var _iterator16 = _createForOfIteratorHelper(this.plugins),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var plugin = _step16.value;

          if (plugin.requiresCanvas()) {
            var frame = plugin.sizeToVideo() ? videoFrame : containerFrame;

            if (Math.abs(plugin.pixi.screen.width - frame.w) > 2 || Math.abs(plugin.pixi.screen.height - frame.h) > 2) {
              console.log("VideoController: pixi resize ---", plugin._name, "w", frame.w, plugin.pixi.screen.width, "h", frame.h, plugin.pixi.screen.height);
              plugin.pixi.width = Math.round(frame.w);
              plugin.pixi.height = Math.round(frame.h);
              plugin.pixi.screen.width = Math.round(frame.w);
              plugin.pixi.screen.height = Math.round(frame.h);
              plugin.pixi.resize();

              if (plugin.sizeToVideo()) {
                plugin.canvas.style.left = "".concat((div.offsetWidth - video.offsetWidth) / 2, "px");
                plugin.canvas.style.top = "".concat((div.offsetHeight - video.offsetHeight) / 2, "px");
              }
            }
          }
        } // Setup and gather shared data

      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }

      var sharedData = {};

      var _iterator17 = _createForOfIteratorHelper(this.plugins),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _plugin = _step17.value;

          if (!_plugin.scene && _plugin.requiresCanvas() || _plugin.needsSetup) {
            _plugin.videoId = videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.video_id;

            if (_plugin.requiresCanvas()) {
              _plugin.scene = new PIXI.Container();

              _plugin.pixi.stage.addChild(_plugin.scene);
            }

            _plugin.setup(_plugin.sizeToVideo() ? _objectSpread({}, videoFrame) : _objectSpread({}, containerFrame), videoInfo, _plugin.pixi);

            if (_plugin.controlsVideo) {
              _plugin.videoControls = {
                play: this.play,
                pause: this.pause
              };
            }
          }

          var pd = _plugin.dataToShare();

          if (pd) {
            sharedData = Object.assign({}, sharedData, pd);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      var _iterator18 = _createForOfIteratorHelper(this.plugins),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _plugin2 = _step18.value;
          _plugin2.isResizing = this.isResizing;
          _plugin2._sharedData = sharedData;
          _plugin2.videoId = videoInfo.video_id;

          _plugin2.update(_plugin2.sizeToVideo() ? _objectSpread({}, videoFrame) : _objectSpread({}, containerFrame), videoInfo, _plugin2.pixi);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }

      var dtime = Date.now() - stime;

      if (dtime > 300) {
        console.warn("drawUpdate took ".concat(dtime, "ms"));
      }
    }
    /*
     * Video Player Interface
     */

    /*
     *  Video updates
     */

  }, {
    key: "buildVideoInfo",
    value: function buildVideoInfo() {
      var _this$moment, _this$controllingSour9, _this$controllingSour10;

      var sourceCount = 1;

      if ((_this$moment = this.moment) !== null && _this$moment !== void 0 && _this$moment.sources && Array.isArray(this.moment.sources)) {
        sourceCount = this.moment.sources.length + 1;
      }

      var camera = this.cameraForMoment((_this$controllingSour9 = this.controllingSource) === null || _this$controllingSour9 === void 0 ? void 0 : _this$controllingSour9.moment);

      if (!((_this$controllingSour10 = this.controllingSource) !== null && _this$controllingSour10 !== void 0 && _this$controllingSour10.video)) {
        var _this$_lastReadyState;

        return {
          loopCount: this.loopCount,
          paused: true,
          duration: 15,
          currentTime: 0.1,
          gameTime: 0.1,
          progress: 0.1,
          active: this.active,
          video_id: this.videoId,
          moment: this.moment,
          sourceCount: sourceCount,
          readyState: (_this$_lastReadyState = this._lastReadyState) !== null && _this$_lastReadyState !== void 0 ? _this$_lastReadyState : 0,
          multicamOpen: false,
          fullscreen: this.isFullscreen,
          camera: (0, _.getProperty)("name", camera, "tracecam"),
          network_speed: this._networkSpeed,
          loading_mode: this.loadingMode,
          scrubber: {
            duration: 0,
            currentTime: 0
          },
          fluid: {
            startAt: this.startAt,
            stopAt: this.stopAt
          },
          insideMoment: false,
          currentMoment: null,
          initialLoading: true
        };
      }

      if (this._lastReadyState >= 3 && this.controllingSource.video.readyState < 3) {
        this._bufferingCount++;
      }

      this._lastReadyState = this.controllingSource.video.readyState;
      var readyState = (0, _.getProperty)("video.readyState", this.controllingSource, this._lastReadyState);
      var duration = this.controllingSource.video.duration;
      var currentTime = this.controllingSource.video.currentTime;
      var scrubberTime = this.controllingSource.video.currentTime;
      var scrubberDuration = duration;
      var startAt = this.startAt;
      var stopAt = this.stopAt;

      if (this.fluid) {
        startAt = this._playlistController.fluidStart();
        stopAt = this._playlistController.fluidStop();
        scrubberTime = this._playlistController.fluidCurrentTime(this.controllingSource.video.currentTime, this.controllingSource.moment);
        scrubberDuration = this._playlistController.fluidDuration();
      } // Update inside moment


      this.insideMoment = this._playlistController.insideMoment;
      var info = {
        loopCount: this.loopCount,
        paused: this.controllingSource.video.paused,
        duration: duration,
        currentTime: currentTime,
        gameTime: 0,
        progress: currentTime / duration * 100,
        active: this.active,
        video_id: this.videoId,
        moment: (0, _.getProperty)("moment", this.controllingSource, null),
        sourceCount: sourceCount,
        readyState: readyState,
        multicamOpen: this.sourceChooserOpen,
        fullscreen: this.isFullscreen,
        camera: (0, _.getProperty)("name", camera, "tracecam"),
        network_speed: this._networkSpeed,
        loading_mode: this.loadingMode,
        scrubber: {
          duration: scrubberDuration,
          currentTime: scrubberTime
        },
        insideMoment: this.insideMoment,
        fluid: {
          startAt: startAt,
          stopAt: stopAt
        },
        currentMoment: this._playlistController.currentMoment,
        initialLoading: this.initialLoading
      };
      return info;
    }
  }, {
    key: "sendVideoInfoUpdate",
    value: function sendVideoInfoUpdate(vi) {
      var _this$controllingSour11;

      if ((_this$controllingSour11 = this.controllingSource) !== null && _this$controllingSour11 !== void 0 && _this$controllingSour11.video && !this.initialLoading) {
        var update = vi ? vi : this.buildVideoInfo();
        var sig = JSON.stringify(update);

        if (sig !== this._lastVideoInfoUpdate) {
          this._lastVideoInfoUpdate = sig;
          document.dispatchEvent(new CustomEvent("trc-video-info", {
            detail: update
          }));
        }
      } else if (this.initialLoading) {
        var _update2 = vi ? vi : this.buildVideoInfo();

        _update2.loopCount = 0;
        _update2.paused = false;
        _update2.duration = 15;
        _update2.currentTime = 0.1;
        _update2.progress = 0.1;
        _update2.network_speed = 1;
        _update2.loading_mode = 1;

        if (this._playlistController._waitingToJumpTo) {
          _update2.scrubber.currentTime = this._playlistController._waitingToJumpTo;
        } else if (this.fluid) {
          var t = 0;

          if (this._playlistController.currentMoment && this._playlistController.firstMainFluidSource()) {
            t = this._playlistController.currentMoment.start_time;
            t = t - this._playlistController.firstMainFluidSource().start_time;
            t = t / 1000;
          }

          _update2.scrubber.currentTime = t;
        }

        var _sig = JSON.stringify(_update2);

        if (_sig !== this._lastVideoInfoUpdate) {
          this._lastVideoInfoUpdate = _sig;
          document.dispatchEvent(new CustomEvent("trc-video-info-loading", {
            detail: _update2
          }));
        }
      }
    } //! Video loading and setup

  }, {
    key: "setupEventHandlers",
    value: function setupEventHandlers() {
      if (this.containerElement && this.needsSetup) {
        this.needsSetup = false;
        window.addEventListener("resize", this.onWindowResize);
        document.addEventListener("trc-play", this.onPlay);
        document.addEventListener("trc-pause", this.onPause);
        document.addEventListener("trc-jump", this.onJump);
        document.addEventListener("trc-jump-forward", this.onJumpForward);
        document.addEventListener("trc-jump-back", this.onJumpBackward);
        document.addEventListener("controls-active", this.onControlsActiveStart);
        document.addEventListener("controls-inactive", this.onControlsActiveEnd);
        document.addEventListener("trc-fullscreen-enter", this.onFullscreenEnter);
        document.addEventListener("trc-fullscreen-exit", this.onFullscreenExit);
        window.addEventListener("resize", this.onResize);
        window.addEventListener("orientationchange", this.onResize);
        this.canvasContainerElement.addEventListener("mousemove", this.onInteraction);
        this.canvasContainerElement.addEventListener("mousedown", this.onInteraction);
        this.canvasContainerElement.addEventListener("mouseup", this.onInteraction);
        this.canvasContainerElement.addEventListener("touchstart", this.onInteraction);
        this.canvasContainerElement.addEventListener("touchmove", this.onInteraction);
        this.canvasContainerElement.addEventListener("touchend", this.onInteraction);

        var _iterator19 = _createForOfIteratorHelper(this.videoElements),
            _step19;

        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var video = _step19.value;
            video.addEventListener("ended", this.onSomeVideoEnded);
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
      }
    }
    /**
     * generates a mp3 url from a moment
     *
     * @param {Moment} moment
     * @return {string} mp3 url
     * @memberof VideoController
     */

  }, {
    key: "generateAudioUrlForStream",
    value: function generateAudioUrlForStream(moment) {
      var url = "".concat(moment.base_path).concat(moment.dynamic_audio);

      if (!url.startsWith("http") && process.env.REACT_APP_VIDEO_PLAYER_API) {
        url = "".concat(process.env.REACT_APP_VIDEO_PLAYER_API).concat(url);
      }

      return url;
    }
    /**
     * generates a hls url from a moment
     *
     * @param {Moment} moment
     * @return {string} hsl url
     * @memberof VideoController
     */

  }, {
    key: "generateHlsUrlForStream",
    value: function generateHlsUrlForStream(moment) {
      var url = "".concat(moment.base_path).concat(moment.dynamic_hls);

      if (!url.startsWith("http") && process.env.REACT_APP_VIDEO_PLAYER_API) {
        url = "".concat(process.env.REACT_APP_VIDEO_PLAYER_API).concat(url);
      }

      return url;
    }
    /**
     * generates a 100k hls url from a moment
     *
     * @param {Moment} moment
     * @return {string} hsl url
     * @memberof VideoController
     */

  }, {
    key: "generateMiniHlsUrlForStream",
    value: function generateMiniHlsUrlForStream(moment) {
      var miniUrl;

      if ((0, _.getProperty)("meta.mini", moment, false)) {
        var url = this.generateHlsUrlForStream(moment);
        var parts = url.split("/");
        var lastPart = parts[parts.length - 1];
        lastPart = "mini_".concat(lastPart);
        parts[parts.length - 1] = lastPart;
        miniUrl = parts.join("/");
      } else {
        var _url = this.generateHlsUrlForStream(moment);

        var _parts = _url.split("/");

        var _lastPart = _parts[_parts.length - 1];
        _lastPart = _lastPart.replace("hls", "");
        _lastPart = _lastPart.replace("game_video", "");
        _lastPart = _lastPart.replace(".m3u8", "video_1000k.m3u8");
        _parts[_parts.length - 1] = _lastPart;
        miniUrl = _parts.join("/");
      }

      return miniUrl;
    }
    /**
     * load all the video sources
     *
     * @param {*} updateAll
     * @memberof VideoController
     */

  }, {
    key: "loadVideo",
    value: function loadVideo(updateAll) {
      var _this2 = this;

      if (this.mainSources.length === 0 && this.videoElements.length > 0) {
        this.generateSources(this.moment);
      }

      if (this.videoElements.length > 0 && this.controllingSource && this.controllingSource.moment && this.needsLoad) {
        this.mainQueue.addItem(new _PositionVideosJob.PositionVideosJob(this.mainSources, this.subSources, this.containerElement, this.subVideoContainerElement, this.videoElements, this.sourceChooserOpen));

        if (this.sourceChooserOpen) {
          this.mainQueue.addItem(new _UpdateSubSourcesJob.UpdateSubSourcesJob(this));
        } // prevent double loading


        this._lastReadyState = 0;
        this.needsLoad = false; // reset stuff

        this.loopCount = 0;
        this.track = null; // setup tracker

        var dynamicVideo = (0, _.getProperty)("moment.dynamic_video_url", this.controllingSource, null);

        if (this.track === null && dynamicVideo === null) {
          var _this$controllingSour12;

          var cam = this.cameraForMoment((_this$controllingSour12 = this.controllingSource) === null || _this$controllingSour12 === void 0 ? void 0 : _this$controllingSour12.moment);
          this.track = new _.VideoTracker(this.controllingSource.moment.game_clip_id, this.playlistId, this.userId, this.playlistType, this.category, this.action, (0, _.getProperty)("type", cam, "Trace"), this.playerType);
          this.track.videoCount(this.controllingSource.moment.game_clip_id);
          this.track.videoStart();
        }

        var startAt = 0;

        if (this.startAt) {
          startAt = this.startAt;
          this.fluidStart = startAt;
        } else if (this.startAtOnce) {
          startAt = this.startAtOnce;
          this.startAtOnce = null;
        } else if (this.resumeAt) {
          startAt = this.resumeAt;
          this.resumeAt = null;
        }

        if (this.fluid) {
          startAt = this._playlistController.fluidStart();
        }

        var shouldAutoPlay = !!this.freeze || this.pendingPause ? false : true;
        this.mainQueue.addItem(new _LoadMainStreamJob.LoadMainStreamJob(this.controllingSource, this.generateHlsUrlForStream(this.controllingSource.moment), {
          startAt: startAt,
          mainSources: this.mainSources,
          level: this.loadingMode,
          autoPlay: shouldAutoPlay,
          autoPause: !shouldAutoPlay,
          muted: this.muted
        }));
        this.mainQueue.add(function () {
          _this2.initialLoading = false;
          _this2._firstLoadComplete = true;
          var readyEvent = new CustomEvent("trc-video-on-ready", {
            detail: _this2.buildVideoInfo()
          });
          document.dispatchEvent(readyEvent);
        });
        this.mainQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this2$controllingSou;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(((_this2$controllingSou = _this2.controllingSource) === null || _this2$controllingSou === void 0 ? void 0 : _this2$controllingSou.video.readyState) < 3)) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 3;
                  return _this2.sleep(100);

                case 3:
                  _context2.next = 0;
                  break;

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))); // this.mainQueue.add(() => {
        //     this.doVideoInfoUpdateLocked = false
        // })

        var momentType = (0, _.getProperty)("moment.meta.type", this.controllingSource, "");

        if (momentType === "CoachAudio" && this.audioElements.length > 0) {
          // we also need to load the audio for coach audio moments
          this.mainQueue.addItem(new _LoadCoachAudioJob.LoadCoachAudioJob(this.audioElements[0], this.generateAudioUrlForStream(this.controllingSource.moment)));
        }

        if (!this._networkSpeed) {
          this.mainQueue.addItem(new _SpeedTestJob.SpeedTestJob(this));
        } // setup pixi drawing if needed


        var hasPixi = false;

        var _iterator20 = _createForOfIteratorHelper(this.plugins),
            _step20;

        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var plugin = _step20.value;

            if (plugin.pixi) {
              hasPixi = true;
              break;
            }
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }

        if (!hasPixi) {
          this.drawSetup(this.doVideoInfoUpdate());
        }
      }
    } // !MultiCam

  }, {
    key: "isMulticam",
    get: function get() {
      return this.moment && this.moment.sources && this.moment.sources.length > 1;
    }
  }, {
    key: "toggleMulticam",
    value: function toggleMulticam(e) {
      var shouldOpen = !this.sourceChooserOpen;
      var eventAction = shouldOpen ? "Multicam Drawer Opened" : "Multicam Drawer Closed";
      (0, _Tracker.trackEvent)({
        action: eventAction,
        label: "Toggle Multicam",
        element: e ? e.target : null
      });
      this.sourceChooserOpen = shouldOpen;
      this.mainQueue.clear();
      var positionJob = new _PositionVideosJob.PositionVideosJob(this.mainSources, this.subSources, this.containerElement, this.subVideoContainerElement, this.videoElements, this.sourceChooserOpen);

      if (this.sourceChooserOpen) {
        this.mainQueue.addItem(positionJob);
        this.loadVideoForMultiCam(-1, this.paused);
      } else {
        this.mainQueue.clear();
        this.mainQueue.addItem(positionJob);
        this.unloadVideoForMultiCam();
      }
    }
    /**
     * loadVideoForMultiCam will clear the main queue and then add
     * jobs to pause, switch, load, and play, and sync the videos for the
     * camera specified by the controlling source.
     *
     * @param {number} [autoStartLoad=-1] - The utc time the new controlling source should start playing from
     * @param {boolean} [wasPaused=false] - Whether the controlling source was paused before the switch
     * @memberof VideoController
     */

  }, {
    key: "loadVideoForMultiCam",
    value: function loadVideoForMultiCam() {
      var _this3 = this;

      var autoStartLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var wasPaused = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var includeMain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (includeMain) {
        this.initialLoading = true;
        this.doVideoInfoUpdateLocked = true;
        this.mainQueue.clear();
      }

      this.mainQueue.addItem(new _PositionVideosJob.PositionVideosJob(this.mainSources, this.subSources, this.containerElement, this.subVideoContainerElement, this.videoElements, this.sourceChooserOpen)); // Pause video for the switch

      if (!wasPaused && includeMain) {
        this.mainQueue.addItem(new _PauseJob.PauseJob(this));
      } // sync videos to hide and show the correct ones


      this.mainQueue.addItem(new _SyncSourcesJob.SyncSourcesJob(this)); //// all modes, load the main stream
      // active main video

      if (includeMain && this.controllingSource && this.controllingSource.moment) {
        this.mainQueue.addItem(new _SwitchToMainStreamJob.SwitchToMainStreamJob(this.controllingSource, this.generateHlsUrlForStream(this.controllingSource.moment), {
          startAtUTC: autoStartLoad,
          level: this.loadingMode,
          mainSources: this.mainSources,
          muted: this.muted
        })); // i dont think we need this anymore
        // this.mainQueue.addItem(new StartPixiTickerJob(this))
      } else if (includeMain) {
        console.warn("VideoController.loadVideoForMultiCam no controlling source");
      }

      if (includeMain) {
        if (!wasPaused) {
          // resume if needed
          this.mainQueue.addItem(new _PlayJob.PlayJob(this));
        } else {
          // make sure newly loaded stuff is paused cuz the player is paused
          this.mainQueue.addItem(new _PauseJob.PauseJob(this));
        }
      } // unlock video info updates


      if (includeMain) {
        this.mainQueue.add(function () {
          _this3.doVideoInfoUpdateLocked = false;
          _this3.initialLoading = false;
        });
      }

      var controllingId = (0, _.getProperty)("video.id", this.controllingSource); // load background main videos
      // if (this.loadingMode > LoadingMode.LOW) {
      //     let count = 0
      //     for (let source of this.mainSources) {
      //         let sourceId = getProperty("video.id", source)
      //         if (sourceId !== controllingId && source.moment) {
      //             this.mainQueue.addItem(
      //                 new LoadMainBackgroundStreamJob(
      //                     source,
      //                     this.generateHlsUrlForStream(source.moment),
      //                     {
      //                         level: this.loadingMode,
      //                         mainSources: this.mainSources,
      //                         autoPlay: !wasPaused,
      //                     }
      //                 )
      //             )
      //             count++
      //         }
      //         if (count > 2) {
      //             // load at most 3 background videos
      //             break
      //         }
      //     }
      // } else {
      // unload background main videos for med and low mode

      var _iterator21 = _createForOfIteratorHelper(this.mainSources),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var source = _step21.value;
          var sourceId = (0, _.getProperty)("video.id", source);

          if (sourceId !== controllingId && source.moment) {
            this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(source));
          }
        } // }
        // sub videos
        // let maxSubs = 0
        // if (this.loadingMode > LoadingMode.LOW) {
        //     maxSubs = 0
        // }
        // let subCount = 0
        // for (let source of this.subSources) {
        //     if (source.moment) {
        //         subCount++
        //         this.mainQueue.addItem(
        //             new LoadSubStreamJob(
        //                 source,
        //                 this.generateMiniHlsUrlForStream(source.moment),
        //                 {
        //                     level: this.loadingLevel,
        //                     //startAt: autoStartLoad,
        //                     autoPlay: !wasPaused,
        //                 }
        //             )
        //         )
        //         if (subCount >= maxSubs) {
        //             break
        //         }
        //     }
        // }

      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      this.mainQueue.addItem(new _SyncSourcesJob.SyncSourcesJob(this));
    }
  }, {
    key: "unloadVideoForMultiCam",
    value: function unloadVideoForMultiCam() {
      var controllingId = (0, _.getProperty)("video.id", this.controllingSource);

      var _iterator22 = _createForOfIteratorHelper(this.mainSources),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var source = _step22.value;
          var sourceId = (0, _.getProperty)("video.id", source);

          if (source.hls && controllingId !== sourceId) {
            this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(source));
          }
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }

      var _iterator23 = _createForOfIteratorHelper(this.subSources),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _source4 = _step23.value;

          if (_source4.hls) {
            this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(_source4));
          }
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }
  }, {
    key: "nextSource",
    value: function nextSource() {
      if (this.mainSources.length < 1) {
        return {
          next: null,
          didLoop: false
        };
      }

      var nextSource = this.mainSources[0];
      var nextIsNext = false;

      var _iterator24 = _createForOfIteratorHelper(this.mainSources),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var source = _step24.value;

          if (source.video.id === this.controllingSource.video.id) {
            nextIsNext = true;
          } else if (nextIsNext && source.hls) {
            nextSource = source;
            break;
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }

      return {
        next: nextSource,
        didLoop: nextSource.video.id === this.mainSources[0].video.id
      };
    }
  }, {
    key: "onChangeSource",
    value: function onChangeSource(targetId) {
      var selectedSource = null;

      var _iterator25 = _createForOfIteratorHelper(this.subSources),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var src = _step25.value;

          if (src.video.id === targetId) {
            selectedSource = src;
            break;
          }
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }

      if (selectedSource) {
        var _selectedSource;

        // eslint-disable-next-line eqeqeq
        if (((_selectedSource = selectedSource) === null || _selectedSource === void 0 ? void 0 : _selectedSource.video.style["opacity"]) == 1) {
          this.changeSource(targetId);
        } else {
          console.warn("VideoController.onChangeSource video not in current time");
        }
      } else {
        console.warn("VideoController.onChangeSource no source found");
      }
    }
  }, {
    key: "changeSource",
    value: function changeSource(targetId) {
      var resume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var utcTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

      // protect against changing source to the same source
      if (targetId === (0, _.getProperty)("video.id", this.controllingSource, null)) {
        console.warn("VideoController.changeSource abort same source", targetId);
        return;
      }

      var prevTime = -1;
      var wasPaused = this.paused;

      if (this.controllingSource && this.controllingSource.video) {
        if (resume) {
          this.startAtOnce = this.controllingSource.video.currentTime;
        }

        prevTime = this.controllingSource.video.currentTime;
      } // load and poistion videos


      var prevUTC = prevTime;

      if (prevTime >= 0) {
        var momentRange = _TimeRange.TimeRange.fromMoment(this.controllingSource.moment);

        prevUTC = momentRange.start.utcSeconds + prevTime;
      }

      if (utcTo >= 0) {
        prevUTC = utcTo;
      }

      var selectedSource = null;

      var _iterator26 = _createForOfIteratorHelper(this.subSources),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _src4 = _step26.value;

          if (_src4.video.id === targetId) {
            selectedSource = _src4;
            break;
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }

      if (selectedSource === null) {
        var _iterator27 = _createForOfIteratorHelper(this.mainSources),
            _step27;

        try {
          for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
            var src = _step27.value;

            if (src.video.id === targetId) {
              selectedSource = src;
              break;
            }
          }
        } catch (err) {
          _iterator27.e(err);
        } finally {
          _iterator27.f();
        }
      }

      if (selectedSource && !selectedSource.moment) {
        // abort this source doesn't have a moment
        return;
      } // update active state of sources


      if (selectedSource !== null) {
        var _iterator28 = _createForOfIteratorHelper(this.mainSources),
            _step28;

        try {
          for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
            var _src2$moment, _selectedSource2;

            var _src2 = _step28.value;
            _src2.active = ((_src2$moment = _src2.moment) === null || _src2$moment === void 0 ? void 0 : _src2$moment.game_clip_id) === ((_selectedSource2 = selectedSource) === null || _selectedSource2 === void 0 ? void 0 : _selectedSource2.moment.game_clip_id);
          }
        } catch (err) {
          _iterator28.e(err);
        } finally {
          _iterator28.f();
        }

        var _iterator29 = _createForOfIteratorHelper(this.subSources),
            _step29;

        try {
          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
            var _src3$moment, _selectedSource$momen;

            var _src3 = _step29.value;
            _src3.active = ((_src3$moment = _src3.moment) === null || _src3$moment === void 0 ? void 0 : _src3$moment.game_clip_id) === ((_selectedSource$momen = selectedSource.moment) === null || _selectedSource$momen === void 0 ? void 0 : _selectedSource$momen.game_clip_id);
          }
        } catch (err) {
          _iterator29.e(err);
        } finally {
          _iterator29.f();
        }
      }

      this.resumeAt = prevTime;
      this.doVideoInfoUpdateLocked = true;
      this.loadVideoForMultiCam(prevUTC, wasPaused); // setup tracker

      if (this.controllingSource && this.controllingSource.moment) {
        var _this$controllingSour13;

        var cam = this.cameraForMoment((_this$controllingSour13 = this.controllingSource) === null || _this$controllingSour13 === void 0 ? void 0 : _this$controllingSour13.moment);
        this.track = new _.VideoTracker((0, _.getProperty)("moment.game_clip_id", this.controllingSource), this.playlistId, this.userId, this.playlistType, this.category, this.action, (0, _.getProperty)("type", cam, "Trace"), this.playerType);
        this.track.videoCount((0, _.getProperty)("moment.game_clip_id", this.controllingSource));
        this.createDisplayMomentTracker();
      }

      if (selectedSource) {
        this._playlistController.camera = selectedSource.camera;
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent("trc-source-changed", {
            detail: selectedSource.camera
          }));
        }, 300);
      }
    }
  }, {
    key: "selectCameraByName",
    value: function selectCameraByName(camera) {
      var firstSource = this._playlistController.firstMainFluidSource();

      var time = _Time.Time.fromMoment(firstSource);

      time.addSeconds(this._playlistController.fluidStart());
      var cameraId = null;
      var cameraGameClipId = null; //filter main sources by if they exist at the current time
      // OR set default camera when camera changes

      var _iterator30 = _createForOfIteratorHelper(this.mainSources),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var src = _step30.value;
          cameraGameClipId = (0, _.getProperty)("moment.game_clip_id", src, null);

          var srcRange = _TimeRange.TimeRange.fromMoment(src === null || src === void 0 ? void 0 : src.moment);

          var cam = this.cameraForMoment(src === null || src === void 0 ? void 0 : src.moment);
          var cameraName = (0, _.getProperty)("name", cam, null);

          if (cameraName === camera && srcRange.contains(time)) {
            cameraId = cameraGameClipId;
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }

      if (!cameraId) {
        console.warn("VideoController.selectCameraByName no camera found");
        return;
      }

      var id = "".concat(this.videoId, "-main-").concat(camera, "-").concat(cameraId);
      this._playlistController.camera = camera;
      this.defaultCamera = camera;

      if (this.controllingSource && this.controllingSource.video) {
        this.changeSource(id, true, time.utcSeconds);
      }
    }
  }, {
    key: "selectCamera",
    value: function selectCamera(camera, utcTo) {
      var resume = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var cameraId = null;
      var cameraGameClipId = null; //filter main sources by if they exist at the current time
      // OR set default camera when camera changes

      var _iterator31 = _createForOfIteratorHelper(this.mainSources),
          _step31;

      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var src = _step31.value;
          cameraGameClipId = (0, _.getProperty)("moment.game_clip_id", src, null);
          var cam = this.cameraForMoment(src === null || src === void 0 ? void 0 : src.moment);
          var cameraName = (0, _.getProperty)("name", cam, null);

          if (cameraName === camera) {
            var _src$container;

            if (((_src$container = src.container) === null || _src$container === void 0 ? void 0 : _src$container.style["display"]) !== "none") {
              cameraId = cameraGameClipId;
            }
          }
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }

      if (!cameraId) {
        return;
      }

      var id = "".concat(this.videoId, "-main-").concat(camera, "-").concat(cameraId);
      this._playlistController.camera = camera;
      this.defaultCamera = camera;

      if (this.controllingSource && this.controllingSource.video) {
        this.changeSource(id, resume, utcTo);
      }
    } //! Video Controls

    /**
     * Play the video, direct control
     *
     * @memberof VideoController
     */

  }, {
    key: "play",
    value: function play() {
      this.videoControlsQueue.addItem(new _PlayJob.PlayJob(this));
      this.videoControlsQueue.addItem(new _VideoInfoUpdateJob.VideoInfoUpdateJob(this));
    }
    /**
     * Play the video, indirectly from the UI
     * @param {*} e
     * @memberof VideoController
     */

  }, {
    key: "onPlay",
    value: function onPlay(e) {
      if (this.track) {
        this.track.videoPlay();
      }

      this.play();
      this.activityDetected();
    }
    /**
     * pause the video, direct control
     *
     * @memberof VideoController
     */

  }, {
    key: "pause",
    value: function pause() {
      // console.log("TEST we're calling pause")
      this.videoControlsQueue.addItem(new _PauseJob.PauseJob(this));
      this.videoControlsQueue.addItem(new _VideoInfoUpdateJob.VideoInfoUpdateJob(this));
    }
    /**
     * pause the video, indirectly from the UI
     *
     * @memberof VideoController
     */

  }, {
    key: "onPause",
    value: function onPause() {
      if (this.track) {
        this.track.videoPause();
      }

      this.pause();
      this.activityDetected();
    }
    /**
     * jump to a specific time in the video, direct control
     *
     * @param {Number} to
     * @memberof VideoController
     */

  }, {
    key: "jump",
    value: function jump(t) {
      this.videoControlsQueue.addItem(new _SeekJob.SeekJob(this, t));
    }
    /**
     * jump to a specific time in the video, indirectly from the UI
     *
     * @param {Object} e
     * @param {Number} e.to
     * @memberof VideoController
     */

  }, {
    key: "onJump",
    value: function onJump(e) {
      var to = e.detail;
      this.jump(to);
      this.activityDetected();
    }
    /**
     * jump the video head forward a given amount of time, direct control
     *
     * @param {Number} amt
     * @memberof VideoController
     */

  }, {
    key: "jumpForward",
    value: function jumpForward(amt) {
      var _this$controllingSour14;

      if ((_this$controllingSour14 = this.controllingSource) !== null && _this$controllingSour14 !== void 0 && _this$controllingSour14.video) {
        var tm = this.controllingSource.video.currentTime;
        tm += amt;

        if (tm > this.controllingSource.video.duration - 2) {
          tm = this.controllingSource.video.duration - 2;
        }

        this.jump(tm);
      }
    }
    /**
     * jump the video head forward a given amount of time, indirectly from the UI
     *
     * @param {Object} e
     * @param {Number} e.detail
     * @memberof VideoController
     */

  }, {
    key: "onJumpForward",
    value: function onJumpForward(e) {
      var amt = e.detail;
      this.jumpForward(amt);
      this.activityDetected();
    }
    /**
     * jump the video head backward a given amount of time, direct control
     *
     * @param {Number} amt
     * @memberof VideoController
     */

  }, {
    key: "jumpBackward",
    value: function jumpBackward(amt) {
      var _this$controllingSour15;

      if ((_this$controllingSour15 = this.controllingSource) !== null && _this$controllingSour15 !== void 0 && _this$controllingSour15.video) {
        var tm = this.controllingSource.video.currentTime;
        tm -= amt;

        if (tm < 0) {
          tm = 0;
        }

        this.jump(tm);
      }
    }
    /**
     * jump the video head backward a given amount of time, indirectly from the UI
     *
     * @param {Object} e
     * @params {Number} e.detail
     * @memberof VideoController
     */

  }, {
    key: "onJumpBackward",
    value: function onJumpBackward(e) {
      var amt = e.detail;
      this.jumpBackward(amt);
      this.activityDetected();
    }
    /**
     * mark active as true, set a timeout to mark active as false
     *
     * @param {*} e
     * @memberof VideoController
     */

  }, {
    key: "activityDetected",
    value: function activityDetected(e) {
      var _this4 = this;

      if (e) {
        // debounce events
        if (this.activityDetectedDebounce) {
          return;
        } // toggle active


        if (e.type === "mousemove") {
          this.active = true;
        } else {
          this.active = !this.active;
        } // clear active timeout


        if (this.activeTimeout) {
          clearTimeout(this.activeTimeout);
          this.activeTimeout = null;
        } // set debouce timeout


        this.activityDetectedDebounce = setTimeout(function () {
          _this4.activityDetectedDebounce = null;
        }, 250); // set active timeout

        if (this.active) {
          this.activeTimeout = setTimeout(function () {
            _this4.activeTimeout = null;
            var overControls = false;

            if (_this4.containerElement && _this4.lastMouseLocation) {
              var videoControls = _this4.containerElement.querySelector(".VideoPlayerControls");

              if (videoControls) {
                var rect = videoControls.getBoundingClientRect(); // is last mouse over the video controls rect?

                overControls = rect.left < _this4.lastMouseLocation.x && rect.right > _this4.lastMouseLocation.x && rect.top < _this4.lastMouseLocation.y && rect.bottom > _this4.lastMouseLocation.y;
              }
            }

            if (!overControls) {
              _this4.active = false;
              _this4.activeTimeout = null;
            }
          }, 2000);
        }
      }
    }
    /**
     * called when a UI event is fired in the video player elements.
     * This methods will pass the event to any plugins that might
     * need to override behavior
     *
     * @param {Event} e
     * @memberof VideoController
     */

  }, {
    key: "onInteraction",
    value: function onInteraction(e) {
      if (e.clientX && e.clientY) {
        var dist = Math.sqrt(Math.pow(e.clientX - this.lastMouseLocation.x, 2) + Math.pow(e.clientY - this.lastMouseLocation.y, 2));
        this.lastMouseLocation = {
          x: e.clientX,
          y: e.clientY
        };

        if (dist > 5) {
          this.activityDetected(e);
        }
      } else if (e.type !== "mousemove") {
        this.activityDetected(e);
      }

      var handled = false;

      var _iterator32 = _createForOfIteratorHelper(this.plugins),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var plugin = _step32.value;

          if (!plugin.on(e)) {
            handled = true;
            break;
          }
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }

      if (!handled && e && e.type === "mouseup") {
        if (typeof this.onVideoClick === "function") {
          this.onVideoClick(e);
        }
      }
    }
    /**
     * set the playback rate of all the video elements
     *
     * @param {Number} rate
     * @memberof VideoController
     */

  }, {
    key: "playbackRate",
    get:
    /**
     * get the playback rate of all the controlling video element
     *
     * @readonly
     * @memberof VideoController
     */
    function get() {
      var _this$controllingSour16;

      var rate = 1;

      if ((_this$controllingSour16 = this.controllingSource) !== null && _this$controllingSour16 !== void 0 && _this$controllingSour16.video) {
        rate = this.controllingSource.video.playbackRate;
      }

      return rate;
    },
    set: function set(rate) {
      if (rate) {
        var _iterator33 = _createForOfIteratorHelper(this.mainSources),
            _step33;

        try {
          for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
            var src = _step33.value;

            if (src.hls) {
              try {
                src.video.playbackRate = rate;
              } catch (e) {
                console.warn(e.message);
              }
            }
          }
        } catch (err) {
          _iterator33.e(err);
        } finally {
          _iterator33.f();
        }

        var _iterator34 = _createForOfIteratorHelper(this.subSources),
            _step34;

        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var _src5 = _step34.value;

            if (_src5.hls) {
              try {
                _src5.video.playbackRate = rate;
              } catch (e) {
                console.warn(e.message);
              }
            }
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }
      }
    }
  }, {
    key: "onFullscreenEnter",
    value: function onFullscreenEnter() {
      this.isFullscreen = true;
    }
  }, {
    key: "onFullscreenExit",
    value: function onFullscreenExit() {
      this.isFullscreen = false;
    } //! Video Event Handlers

    /**
     * onSomeVideoEnded will be called when any video has reached the end of its
     * source.  If that video is the controlling video, it will call
     * onVideoEnded
     *
     * @memberof VideoController
     */

  }, {
    key: "onSomeVideoEnded",
    value: function onSomeVideoEnded(e) {
      if (this.controllingSource && this.controllingSource.video) {
        if (e.target.id === this.controllingSource.video.id) {
          this.onVideoEnded(e);
        }
      }
    }
    /**
     * onVideoEnd will be called when the main video has ended
     * It will
     *  - track video ended events for analytics
     *  - loop the video if loop is set to true
     *  - go to the next video source if multicam is available
     *  - it will loop playback at the startAt position if set
     *  - it will dispatch an video ended event if loop is set to false
     *
     * @param {*} e
     * @return void
     * @memberof VideoController
     */

  }, {
    key: "onVideoEnded",
    value: function onVideoEnded(e) {
      if (this.fluid) {
        if ((0, _isiOS.isiOS)() && this.isFullscreen) {
          var _this$controllingSour17;

          (0, _exitFullScreen.exitFullScreen)(null, (_this$controllingSour17 = this.controllingSource) === null || _this$controllingSour17 === void 0 ? void 0 : _this$controllingSour17.video);
        } else if (this.settings.loop) {
          var startAt = this._playlistController.fluidStart();

          this.jump(startAt);
          this.play();
        } else if (this.settings.locked) {
          this._playlistController.goToNext();
        } else {
          this._playlistController.goToNext();
        }
      } else {
        // Loop in Safari on iOS so we don't have to manage the
        // full screen state specifically for those cases
        var isThisiOS = (0, _isiOS.isiOS)();
        var loop = this.loop || isThisiOS;

        if (loop || this.sourceChooserOpen) {
          var _this$controllingSour18;

          this.loopCount += 1;
          var cam = this.cameraForMoment((_this$controllingSour18 = this.controllingSource) === null || _this$controllingSour18 === void 0 ? void 0 : _this$controllingSour18.moment);
          this.track = new _.VideoTracker(this.controllingSource.moment.game_clip_id, this.playlistId, this.userId, this.playlistType, this.category, this.action, (0, _.getProperty)("type", cam, "Trace"), this.playerType);
          this.track.videoStart();
          this.track.videoCount((0, _.getProperty)("moment.game_clip_id", this.controllingSource, null));
          this.jump(this.startAt);
          this.play();
        } else {
          this.play();
        }
      }
    }
    /**
     * handle window resize events
     *
     * @param {*} e
     * @memberof VideoController
     */

  }, {
    key: "onWindowResize",
    value: function onWindowResize(e) {
      var _this5 = this;

      this.isResizing = true;

      if (this.isResizingTimeout) {
        clearTimeout(this.isResizingTimeout);
        this.isResizingTimeout = null;
      }

      this.mainQueue.addItem(new _PositionVideosJob.PositionVideosJob(this.mainSources, this.subSources, this.containerElement, this.subVideoContainerElement, this.videoElements, this.sourceChooserOpen));
      this.isResizingTimeout = setTimeout(function () {
        _this5.isResizing = false;
        _this5.isResizingTimeout = null;

        _this5.mainQueue.addItem(new _PositionVideosJob.PositionVideosJob(_this5.mainSources, _this5.subSources, _this5.containerElement, _this5.subVideoContainerElement, _this5.videoElements, _this5.sourceChooserOpen));

        _this5.mainQueue.addItem(new _UpdateSubSourcesJob.UpdateSubSourcesJob(_this5));
      }, 400);
    } //! Clean Up

    /**
     * destroy will remove this instance from the factory
     *
     * @memberof VideoController
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;

      console.log("VideoController.destroy()", this.videoId);
      this.stopPixiTicker();
      this.cleanup();
      this.mainQueue.clear();
      this.videoControlsQueue.clear();
      this.mainQueue = null;
      this.videoControlsQueue = null;
      VideoController._instances = VideoController._instances.filter(function (c) {
        return c.id !== _this6.id;
      });
      var hasPixi = false;

      var _iterator35 = _createForOfIteratorHelper(this.plugins),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var _plugin3 = _step35.value;

          if (_plugin3.pixi) {
            hasPixi = true;
          }
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }

      if (hasPixi) {
        var _iterator36 = _createForOfIteratorHelper(this.plugins),
            _step36;

        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var plugin = _step36.value;
            plugin.pixi.destroy(false, true);
            plugin.pixi = null;
            plugin.reset();
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }

        this.plugins = [];
      }

      if (VideoController._instances.length === 0) {
        PIXI.Ticker.shared.stop();
      }
    }
    /**
     * cleans up video player event handlers and intervals
     *
     * @memberof VideoController
     */

  }, {
    key: "cleanup",
    value: function cleanup() {
      this.cleanHls(true);
      this.cleanEventHandlers();
    }
    /**
     * cleanHls will remove the hls instances from the video elements
     *
     * @param {boolean} cleanSubs
     * @memberof VideoController
     */

  }, {
    key: "cleanHls",
    value: function cleanHls(cleanSubs) {
      var _iterator37 = _createForOfIteratorHelper(this.mainSources),
          _step37;

      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var _source5 = _step37.value;

          if (_source5.hls) {
            this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(_source5));
          }
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }

      if (cleanSubs) {
        var _iterator38 = _createForOfIteratorHelper(this.subSources),
            _step38;

        try {
          for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
            var source = _step38.value;

            if (source.hls) {
              this.mainQueue.addItem(new _UnloadStreamJob.UnloadStreamJob(source));
            }
          }
        } catch (err) {
          _iterator38.e(err);
        } finally {
          _iterator38.f();
        }
      }
    }
    /**
     * cleanEventHandlers will remove all event handlers
     *
     * @memberof VideoController
     */

  }, {
    key: "cleanEventHandlers",
    value: function cleanEventHandlers() {
      document.removeEventListener("canplay", this.onPlay);
      document.removeEventListener("trc-play", this.onPlay);
      document.removeEventListener("trc-pause", this.onPause);
      document.removeEventListener("trc-jump", this.onJump);
      document.removeEventListener("trc-jump-forward", this.onJumpForward);
      document.removeEventListener("trc-jump-back", this.onJumpBackward);
      document.removeEventListener("controls-active", this.onControlsActiveStart);
      document.removeEventListener("controls-inactive", this.onControlsActiveEnd);
      document.removeEventListener("trc-fullscreen-enter", this.onFullscreenEnter);
      document.removeEventListener("trc-fullscreen-exit", this.onFullscreenExit);
      window.removeEventListener("resize", this.onResize);
      window.removeEventListener("orientationchange", this.onResize);

      if (this.canvasContainerElement) {
        this.canvasContainerElement.removeEventListener("mousemove", this.onInteraction);
        this.canvasContainerElement.removeEventListener("mousedown", this.onInteraction);
        this.canvasContainerElement.removeEventListener("mouseup", this.onInteraction);
        this.canvasContainerElement.removeEventListener("touchstart", this.onInteraction);
        this.canvasContainerElement.removeEventListener("touchmove", this.onInteraction);
        this.canvasContainerElement.removeEventListener("touchend", this.onInteraction);
      }

      var _iterator39 = _createForOfIteratorHelper(this.videoElements),
          _step39;

      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var video = _step39.value;
          video.removeEventListener("ended", this.onSomeVideoEnded);
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }

      this.needsSetup = true;
    }
  }], [{
    key: "getInstance",
    value: //! Factory Methods
    function getInstance() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (id) {
        var controller = this._instances.find(function (item) {
          return item.id === id;
        });

        if (!controller) {
          controller = new VideoController(id);

          this._instances.push(controller);
        }

        return controller;
      } else {
        return null;
      }
    }
  }]);

  return VideoController;
}();

exports.VideoController = VideoController;

_defineProperty(VideoController, "_instances", []);